export enum DocumentReviewEnum {
  APPROVED,
  REJECTED
}
